<template>
    <div class="login-screen">
        <div class="login-screen-header">
            <app-badge/>
        </div>

        <div class="login-screen-body">
            <invalid-wallboard-number v-if="invalidWallboardNumber"/>

            <failed-to-load-captcha v-else-if="failedToLoadCaptcha"/>

            <auth-card v-else title="login.title">
                <auth-input
                    v-model="password"
                    @input="loginErrors = []"
                    @keyup.enter.native="auth()"
                    :label="$t('login.password-label')"
                    type="password"
                    autocomplete="on"
                    focused
                />

                <auth-errors :errors="loginErrors"/>

                <auth-button
                    @click="auth"
                    :disabled="$v.$invalid"
                    :loading="loginLoading"
                    text="login.login-button"
                />
            </auth-card>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import { required } from 'vuelidate/dist/validators.min.js'
import BaseButton from "../defaults/BaseButton.vue";
import {getCaptchaToken} from "../../helpers/CaptchaHelper";
import BaseInput from "../defaults/BaseInput.vue";
import {saveAccessToken, getWallboardNumber} from "../../utils/auth";
import breakpoints from "../../plugins/breakpoints";
import {logIn} from "../../api/authApi";
import AuthCard from "./base/AuthCard.vue";
import AuthErrors from "./base/AuthErrors.vue";
import AuthButton from "./base/AuthButton.vue";
import AuthInput from "./base/AuthInput.vue";
import AppBadge from "./base/AppBadge.vue";
import FailedToLoadCaptcha from "./FailedToLoadCaptcha.vue";
import InvalidWallboardNumber from "./InvalidWallboardNumber.vue";

export default {
    name: "Login",
    components: {
        InvalidWallboardNumber,
        FailedToLoadCaptcha,
        AppBadge,
        AuthInput,
        AuthButton,
        AuthErrors,
        AuthCard,
        BaseInput,
        BaseButton,
    },
    data() {
        return {
            password: '',
            loginLoading: false,
            loginErrors: [],
            failedToLoadCaptcha: false,
            invalidWallboardNumber: false,
            breakpoints
        }
    },
    computed: {
        ...mapGetters(['captchaKey']),
    },
    created() {
        try {
            getWallboardNumber()
        } catch (e) {
            console.error(e)
            this.invalidWallboardNumber = true
        }
    },
    validations: {
        password: {
            required
        }
    },
    methods: {
        ...mapActions(['changeIsLogged']),

        auth() {
            if (this.$v.$invalid || this.loginLoading) {
                return
            }
            this.loginLoading = true
            this.loginErrors = []
            const password = this.password
            let number

            try {
                number = getWallboardNumber()
            } catch (e) {
                console.error(e)
                this.loginLoading = false
                this.invalidWallboardNumber = true
                return
            }

            getCaptchaToken('login')
                .then((token) => {
                    logIn({ number, password, captcha: token })
                        .then((response) => {
                            saveAccessToken(response.data.access_token)
                            this.changeIsLogged(true)
                            this.$router.push('/')
                        })
                        .catch((err) => {
                            this.changeIsLogged(false)
                            if (err?.response?.data?.message === 'invalid captcha') {
                                this.loginErrors.push('login.captcha-error')
                            } else {
                                this.loginErrors.push('login.invalid-username-or-password')
                            }
                        })
                        .finally(() => {
                            this.loginLoading = false
                        })
                })
                .catch(() => {
                    this.loginLoading = false
                    this.failedToLoadCaptcha = true
                })
        },
    }
}
</script>

<style scoped>

</style>